var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exec-placeholder',{attrs:{"title":"Taquizas — Fase 5 (diferida)","message":"El módulo de taquizas (eventos) no está implementado todavía. Se habilitará al activar el flag events.taquizas en una fase posterior."}})
}
var staticRenderFns = []

export { render, staticRenderFns }